import {
  array,
  useNavigator,
  usePathNameList,
  useStreamValue
} from 'annotation-tools/utils';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { viewTexts } from '../../../constants/view-texts';
import { companyId$, koumutenId$ } from '../../../global-state/router-id';
import { useLoadingPage } from '../../../global-state/show-loading-page';
import { pathnameElements, routes } from '../../../routing/routes';
import { CompanyRootView } from './company-root-view';

const vt = viewTexts.pages.companyRoot;

const tabs = [
  { label: vt.tabLabels.projectList, disabled: false },
  { label: vt.tabLabels.modelList, disabled: false }
];

const pathNameLastToIndex = (pathNameLast: string): number | undefined => {
  switch (pathNameLast) {
    case pathnameElements.projects:
      return 0;
    case pathnameElements.models:
      return 1;
    default:
      return undefined;
  }
};

export const CompanyRoot: FC<{}> = memo(() => {
  const navigator = useNavigator();

  const pathName = usePathNameList();
  const pathNameLast = useMemo(() => array.last(pathName) ?? '', [pathName]);

  const koumutenId = useStreamValue(koumutenId$);
  const companyId = useStreamValue(companyId$);

  // pathnameと対応させるため、routerを使ってタブ切り替えを制御

  const tabIndex = useMemo(
    // dummy comment to control prettier
    () => pathNameLastToIndex(pathNameLast) ?? 0,
    [pathNameLast]
  );

  const tabIndexChange = useCallback(
    (idx: number) => {
      if (koumutenId !== undefined && companyId !== undefined) {
        switch (idx) {
          case 0:
            navigator(routes.projectList(koumutenId, companyId));
            break;
          case 1:
            navigator(routes.modelList(koumutenId, companyId));
            break;
          default:
            break;
        }
      }
    },
    [navigator, koumutenId, companyId]
  );

  useLoadingPage(koumutenId === undefined || companyId === undefined);

  return (
    <>
      {koumutenId === undefined || companyId === undefined ? (
        undefined
      ) : (
        <CompanyRootView
          tabIndex={tabIndex}
          tabIndexChange={tabIndexChange}
          tabs={tabs}
          koumutenId={koumutenId}
          companyId={companyId}
        />
      )}
    </>
  );
});

CompanyRoot.displayName = 'CompanyRoot';
